import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { ToastService } from '../../services/toast.service';
import { ToastPosition, Toast } from '../../../core/models/toast.model';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'umkt-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, IconComponent],
})
export class ToastComponent {
  toastService = inject(ToastService);

  positions: ToastPosition[] = [
    'top-left',
    'top-center',
    'top-right',
    'bottom-left',
    'bottom-center',
    'bottom-right',
  ];

  toastsByPosition = computed(() => {
    const allToasts = this.toastService.toasts();
    const grouped = new Map<ToastPosition, Toast[]>();
    this.positions.forEach(pos => grouped.set(pos, []));
    allToasts.forEach((toast: Toast) => {
      grouped.get(toast.position)?.push(toast);
    });
    return grouped;
  });

  onActionClick(toast: Toast) {
    try {
      toast.action?.onClick();   
    } finally {
      this.toastService.remove(toast.id); 
    }
  }
}
